export default __webpack_public_path__ + "static/media/poco.c6626f12.mp4";